import { createUseStyles } from 'react-jss';
import { breakpoints, colors, boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  form: {
    position: 'relative',
    backgroundColor: colors.neutral.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '1rem',
    boxShadow: boxShadows.dark[16],
    margin: '0 auto',
    padding: '6rem 15rem  2.4rem',
    boxSizing: 'border-box',

    [breakpoints.md.down]: {
      padding: '4rem 6rem  2.4rem',
    },
    [breakpoints.sm.down]: {
      padding: '2.4rem',
    },
  },
  imageWrapper: {
    width: '100%',
    '& img': {
      height: '15rem',
      width: 'auto',
      margin: '0 auto',
      display: 'block',
      [breakpoints.sm.down]: {
        height: '10rem',
      },
    },
    marginBottom: '2rem',
  },
  formContent: {
    margin: '4rem auto',
    width: '100%',
  },
  inputSearchComponent: {
    textAlign: 'left',
    margin: '3.6rem 0 2.6rem',
    '& > ul': {
      position: 'static',
      marginTop: '1rem',
    },
  },
  formTitle: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    letterSpacing: '0.0225em',
    color: colors.neutral[900],
    marginBottom: '1rem',
    marginTop: 0,
    textAlign: 'center',
  },
  formSubtitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    letterSpacing: '0.02em',
    margin: 0,
    color: colors.neutral[700],
    textAlign: 'center',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '3.6rem 0 2.6rem 0',
    [breakpoints.sm.down]: {
      flexDirection: 'column',
      margin: '2rem 0 2.6rem',
      gap: '2rem',
    },
  },
  formZipCodeInput: {
    width: '22%',
    [breakpoints.sm.down]: {
      width: '100%',
    },
  },
  formCountyInput: {
    width: '44%',
    [breakpoints.sm.down]: {
      width: '100%',
    },
  },
  formStateInput: {
    width: '27%',
    [breakpoints.sm.down]: {
      width: '100%',
    },
  },
  formSelect: {
    width: '100%',
    textAlign: 'left',
  },

  ineligibleStateMessage: {
    margin: '0',
    fontSize: '1.6rem',
    color: colors.red[500],
  },
  submitButton: {
    width: '28rem',
    margin: '0 auto 7rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
